export default __webpack_public_path__ + "static/icon-scope-640ad555a524ce71d48a0e8a78ed8e6b.svg";